import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useState , useEffect, useContext } from "react";
import axios from "axios";
import folder from "../../folder.svg";
import DownArrow from "../../arrow-down.svg";
import BASE_URL from "../../BaseUrl";
import "../../styles/admin/FolderContent.css";
import { GlobalContext } from "../GlobalContext";
import Exam from "../../exam.svg";
import CircularProgress from '@mui/material/CircularProgress';

export default function FolderContent({active, setActive, setMobileActive}){
    const navigate = useNavigate();
    const location = useLocation();
    const {parentId} = useParams();
    const {admin, setAdmin} = useContext(GlobalContext);
    const [folderName, setFolderName] = useState("")
    const [loaded , setLoaded] = useState(false);
    const [reload, setReload] = useState(false);
    const [content, setContent] = useState([]);
    const [type, setType] = useState("");
    const [expandedUnitsIds, setExpandedUnitsIds] = useState([]);
    const [lessons,setLessons] = useState({});
    const [exams, setExams] = useState({});
    const [disapleAddingButtons, setDisapleAddingButtons] = useState(false);
    const [newFolder, setNewFolder] = useState({
        folderId:"",
        folderName : "",
        parentId: parentId,
        courseId: location.state? location.state.courseId? location.state.courseId : parentId : parentId,
    })
    const [showNewFolderForm, setShowNewFolderForm] = useState(false);
    const [showEditFolderForm, setShowEditFolderForm] = useState(false);
    const [showEditUnitForm, setShowEditUnitForm] = useState(false)
    const [showEditLessonFrom,setShowEditLessonFrom] = useState(false)
    const [objectToEdit, setObjectToEdit] = useState({});
    const [showDeleteLessonForm, setShowDeleteLessonForm] = useState(false);
    const [objectToDelete, setObjectToDelete] = useState({
        name: "",
        id: "",
    })
    const [typeToDelete, setTypeToDelete] = useState("");
    const [capacityExceeded, setCapacityExceeded] = useState(false);

    const [newUnit, setNewUnit] = useState({
        unitId:"",
        unitName:"",
        folderId:"",
        courseId: location.state? location.state.courseId? location.state.courseId : parentId : parentId 
    })
    const [showNewUnitForm , setShowNewUnitForm] = useState(false);
    const [currentUnit, setCurrentUnit] = useState("");
    const [ShowMessageToStartPlan, setShowMessageToStartPlan] = useState(false);

    const [newLesson,setNewLesson] = useState({
        lessonId:"",
        lessonName:"",
        uploader: admin? admin.id:"",
        timesBuying: 0,
        date: null,
        price: 0.00,
        unitId: currentUnit,
        url:"",
        imageUrl:""
    })


    const [showNewLessonForm, setShowNewLessonForm] = useState(false);

    const [warning, setWarning] = useState("error");
    const [showWarning, setShowWarning] = useState(false);

    const fetchData = async ()=>{
        if(parentId === null || parentId === ""){
            navigate("/admin-home",{state:{admin:admin}});
            return;
        }
        if(admin === null || admin === undefined){
            await axios.get(`${BASE_URL}/teacher/get-admin-by-token`,{withCredentials:true})
                    .then((response)=>{
                        setAdmin(response.data);
                        // setNewFolder({...newFolder, courseId: response.data.courseId});
                        navigate("/admin-home",{state:admin});

                    }).catch((error)=>{
                        navigate("/")
                    })
        }
        await axios.get(`${BASE_URL}/teacher/content?parentId=${parentId}`,{withCredentials:true})
        .then((response)=>{
            setType(response.data.type);
            setContent(response.data.data);
            setFolderName(response.data.folderName);
            setReload(true);
        }).catch((error)=>{
            navigate("/admin-home",{state:{admin:admin}});
        })
        setLoaded(true);
    }
    const updateFolder = ()=>{
        axios.put(`${BASE_URL}/teacher/update-folder`,objectToEdit,{withCredentials: true})
        .then((response)=>{
            setObjectToEdit({})
            setShowEditFolderForm(false);
            setReload(!reload)
        }).catch((error)=>{
        })
    }

    const updateUnit = ()=>{
        axios.put(`${BASE_URL}/teacher/update-unit`,objectToEdit,{withCredentials: true})
        .then((response)=>{
            setObjectToEdit({})
            setShowEditUnitForm(false);
            setReload(!reload)
        }).catch((error)=>{
        })
    }

    const updateLesson = ()=>{
        axios.put(`${BASE_URL}/teacher/update-lesson`,objectToEdit,{withCredentials: true})
        .then((response)=>{
            setObjectToEdit({})
            setShowEditLessonFrom(false);
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
        })
    }

    const changeUrl = (value)=>{
        const splits = value.split('.be/')[1];
        if(splits === null || splits === undefined){
            return;
        }
        const videoId = splits.split("?")[0];
        setNewLesson({...newLesson,imageUrl:`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,url:`https://www.youtube.com/embed/${videoId}`});
    }


    
    const handleRotation = async (e,unitId)=>{
        const img = e.target;
        const currentRotation = img.dataset.rotation? parseInt(img.dataset.rotation): 0;
        const newRotation = currentRotation=== 0 ? 180 : 0;
        if(newRotation !== 0){

            try {
            const lessonsRes = await axios.get(
                `${BASE_URL}/teacher/lessons?unitId=${unitId}`,
                { withCredentials: true }
            );

            setLessons((prev) => ({ ...prev, [unitId]: lessonsRes.data }));

            const examsRes = await axios.get(
                `${BASE_URL}/teacher/unit-exams?unitId=${unitId}`,
                { withCredentials: true }
            );

            setExams((prev) => ({ ...prev, [unitId]: examsRes.data }));

            setExpandedUnitsIds((prev) =>
                prev.includes(unitId) ? prev : [...prev, unitId]
            );

            } catch (error) {
            console.error(error);
            }
            
        }
        else{
            const L2 = {...lessons};
            delete L2[unitId];
            setLessons(L2);
            const E2 = {...exams};
            delete E2[unitId];
            setExams(E2);
            setExpandedUnitsIds(prv=>{
                return prv.filter(id=> id !== unitId);
            })
            // setExams(prv=>{
            //     return prv.filter(id=>id !== unitId);
            // })
        }
        img.style.transform=`rotate(${newRotation}deg)`;
        img.dataset.rotation = newRotation;
    }

    const addNewFolder = async ()=>{
        if(newFolder.folderName === ""){
            setShowWarning(true);
            setWarning("اسم المجلد مطلوب");
            return;
        }
        await axios.post(`${BASE_URL}/teacher/new-folder`,newFolder,{withCredentials:true})
        .then(()=>{
            setShowNewFolderForm(false);
            setWarning('');
            setNewFolder({...newFolder,folderName:""});
            setShowWarning(false);
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
            navigate("/");
        })
    }

    const addNewUnit = async ()=>{
        if(newUnit.unitName === ""){
            setShowWarning(true);
            setWarning("اسم الوحدة مطلوب");
            return;
        }

        await axios.post(`${BASE_URL}/teacher/new-unit`,newUnit,{withCredentials:true})
        .then(()=>{
            setShowNewUnitForm(false);
            setWarning('');
            setNewUnit({...newUnit,unitName:""});
            setShowWarning(false);
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
            navigate("/");
        })
    }
    // reload unit content to show new lesson added or deleted
    const reloadUnit = async (unitId)=>{
        if(expandedUnitsIds.includes(unitId)){
           try{
                const lessonResponse = await axios.get(`${BASE_URL}/teacher/lessons?unitId=${unitId}`,{withCredentials:true});
                const examsResponse = await axios.get(
                    `${BASE_URL}/teacher/unit-exams?unitId=${unitId}`,
                    { withCredentials: true }
                );
                setLessons(prv=>({...prv, [unitId]:lessonResponse.data}));
                setExams(prv=>({...prv, [unitId]:examsResponse.data}))
                const units = expandedUnitsIds;
                units.push(unitId);
                setExpandedUnitsIds(units);
           }catch(error){
            console.log(error);
           }

        }
    }

    const addNewLesson = async()=>{
        setDisapleAddingButtons(true);
        const isExceede = await checkSize();
        if(!isExceede){
            setNewLesson({...newLesson, lessonName:"",price:0,url:"",imageUrl:""});
            setShowNewLessonForm(false);
            return;
        }
        setNewLesson({...newLesson, unitId:currentUnit});
        var theLesson = {...newLesson,unitId:currentUnit};
        axios.post(`${BASE_URL}/teacher/new-lesson?adminId=${admin.id}&folderId=${parentId}&folderName=${folderName}&courseId=${newFolder.courseId}`,theLesson,{withCredentials:true})
            .then(()=>{
                setNewLesson({...newLesson, lessonName:"",price:0,url:"",imageUrl:""});
                setShowNewLessonForm(false);
                reloadUnit(currentUnit);
                setDisapleAddingButtons(false);
            }).catch((error)=>{
                console.log(error);
                navigate("/");
            })
        
    }

    async function checkSize(){
        try{
            await axios.get(`${BASE_URL}/teacher/check-new-lesson`,{withCredentials: true});
            return true;
        }catch (error){
            if(error.response.status === 406){
                    setCapacityExceeded(true);
                }
                else{
                    console.log(error);
                    navigate("/");
                }
                setShowNewLessonForm(false);
                return false;
        }
        
        
    }

    const deleteObject = async ()=>{
        await axios.delete(`${BASE_URL}/teacher/delete-object?id=${objectToDelete.id}&type=${typeToDelete}&courseId=${newFolder.courseId}`, {withCredentials: true})
        .then((response)=>{
            setShowDeleteLessonForm(false);
            setReload(!reload);
            if(typeToDelete === "lesson" || typeToDelete === 'exam'){
                reloadUnit(objectToDelete.unitId);
            }
            else if(typeToDelete === "unit"){
                 setContent(prv=>prv.filter(unit=> unit.unitId !== objectToDelete.id));
            }
            else if(typeToDelete === "folder"){
                setContent(prv=>prv.filter(folder=> folder.folderId !== objectToDelete.id));
            }
            setObjectToDelete({name:"", id:""});
            setTypeToDelete("");
        }).catch((error)=>{
            console.log(error);
            setShowDeleteLessonForm(false);
            setObjectToDelete({name:"", id:""});
            setTypeToDelete("");
        })
    }

    useEffect(()=>{
        fetchData();
        setNewFolder({...newFolder, parentId: parentId});
        setNewUnit({...newUnit, folderId:parentId});
        setActive("المواد الدراسية");
        setMobileActive("courses mobile");
        
    },[reload,location.key]);
    return(
        <div>
            {folderName && (<h3 className="folder-name">{folderName}</h3>)}
            {loaded &&(<div className="folders-nav-container">
                {type !== "unit" &&(
                    <button className="add-new-folder"
                        onClick={()=>setShowNewFolderForm(true)}
                    >اضافة مجلد</button>
                )}

                {type !== "folder" &&(
                    <button className="add-new-folder"
                        onClick={()=>setShowNewUnitForm(true)}
                    >اضافة وحدة</button>
                )}
                
                {type==="folder" && (
                    <div className="folders-container">
                    {content.map((folder1,i)=>(
                    //     <motion.div 
                    //     initial={{opacity:0, x: 50}}
                    //     animate={{opacity: 1 , x : 0}}
                    //     exit={{opacity: 0 , x : 100}}
                    //     className="folder-card-animation"
                    // >
                    <div className={`folder-card-animation ${active=== "المواد الدراسية"? "folder-card-in" : "folder-card-out"}`}>

                        <div className='folder-card' onClick={() => {navigate(`/admin-home/folder/${folder1.folderId}`,{state:{courseId: newFolder.courseId}});}}>
                                <div className="folder-card-buttons">
                                <button className="delete-folder-button"
                                onClick={(e)=>{
                                    e.stopPropagation();
                                    setObjectToDelete({name: folder1.folderName, id: folder1.folderId});
                                    setTypeToDelete("folder");
                                    setShowDeleteLessonForm(true);
                                }} 
                                >حذف</button>
                                <button className="edit-folder-button" onClick={(e)=>{e.stopPropagation();setShowEditFolderForm(true);setObjectToEdit(folder1)}}>تعديل</button>
                                </div>
                                <h4 className="card-folder-name">{folder1.folderName}</h4>
                                <img src={folder} alt='no' className='course-photo'></img>
                    </div>
                    </div>
                    ))}
                </div>)}

                {type==="unit" && (
                    <div className="unit-container">
                    {content.map((unit,index)=>{
                        return(
                            <div className="unit-lessons-container">
                                <div className="unit-card" id={unit.unitId} >
                                    <div className="unit-buttons">
                                        <button className="delete-unit-button"
                                        onClick={()=>{
                                            setObjectToDelete({name: unit.unitName, id: unit.unitId});
                                            setTypeToDelete("unit");
                                            setShowDeleteLessonForm(true);
                                        }}
                                        >حذف الوحدة</button>
                                        <button className="update-unit-button" onClick={()=>{setObjectToEdit(unit); setShowEditUnitForm(true)}}>تعديل</button>
                                        <button className="add-new-lesson"
                                        onClick={(e)=>{
                                            if(admin.capacity === 0){
                                                setShowMessageToStartPlan(true);
                                                return;
                                            }
                                            setCurrentUnit(unit.unitId);
                                            setShowNewLessonForm(true);
                                            
                                            }}>إضافة درس</button>
                                        
                                    </div>
                                    <h4>{unit.unitName}</h4>
                                    <img src={DownArrow} alt="no" className="unit-photo" onClick={(e)=>{handleRotation(e,unit.unitId)}}
                                        style={{ transition: 'transform 0.3s ease-in-out' }}
                                    ></img>
                                </div>
                                {expandedUnitsIds.includes(unit.unitId) && lessons[unit.unitId] !== null && (
                                    <div className="lesson-container">
                                        {(lessons[unit.unitId].map((lesson,index)=>{
                                            return(
                                                <div className="lesson-card" onClick={()=>navigate(`/admin-home/video-details/${lesson.lessonId}`,{state:{courseId:newFolder.courseId, adminId: admin.id}})}>
                                                    <div className="lesson-card-buttons">
                                                        <button className="delete-lesson-button"
                                                    onClick={(e)=>{
                                                        e.stopPropagation();
                                                        setObjectToDelete({name: lesson.lessonName, id: lesson.lessonId, unitId: unit.unitId});
                                                        setTypeToDelete("lesson");
                                                        setShowDeleteLessonForm(true);
                                                    }}
                                                    >حذف</button>
                                                    <button className="update-unit-button" onClick={(e)=>{
                                                        e.stopPropagation();
                                                        setObjectToEdit({lessonId:lesson.lessonId,lessonName: lesson.lessonName, price: lesson.price});
                                                        setShowEditLessonFrom(true);
                                                    }}>تعديل</button>
                                                    </div>
                                                    <h5>{lesson.lessonName}</h5>
                                                    <img className="lesson-image" src={lesson.imageUrl} alt="no"></img>
                                                    
                                                </div>
                                            )
                                        }))}
                                        <div className="exams-cards-button-container">
                                        <button className="new-test-button" onClick={async()=>{
                                            if(admin.capacity === 0){
                                                setShowMessageToStartPlan(true);
                                                return;
                                            }
                                            const isChecked = await checkSize();
                                            if(isChecked){
                                                navigate(`/admin-home/new-exam/${unit.unitId}`);
                                            }
                                        
                                        }}
                                        >اختبار جديد</button>
                                        {expandedUnitsIds.includes(unit.unitId) && exams[unit.unitId] !== null  &&(
                                            
                                                (exams[unit.unitId].map((exam,index)=>{
                                                    return(
                                                    <div className="exam-card" onClick={()=>{
                                                        navigate(`/admin-home/preview-exam/${exam.id}`)
                                                    }}>
                                                        <div className="lesson-card-buttons">
                                                            <button className="delete-lesson-button" onClick={(e)=>{
                                                                e.stopPropagation();
                                                                setObjectToDelete({name:exam.name, id:exam.id, unitId: unit.unitId});
                                                                setTypeToDelete("exam")
                                                                setShowDeleteLessonForm(true);
                                                                
                                                            }}>حذف</button>
                                                            <button className="update-unit-button" onClick={(e)=>{e.stopPropagation();navigate(`/admin-home/edit-exam/${exam.id}`)}}>تعديل</button>
                                                            <button className="update-unit-button" onClick={(e)=>{e.stopPropagation();navigate(`/admin-home/exam-results/${exam.id}`, {state: {examName: exam.name}})}}>النتائج</button>
                                                        </div>
                                                        <h3>{exam.name}</h3>
                                                        <img src={Exam} alt="no"/>
                                                    </div>
                                                    )
                                                }))
                                            
                                            
                                        )}
                                        </div>
                                    </div>
                            
                            )}
                            </div>
                    )})}
                </div>
                )}
                {/* FORMS */}
                {/* add new folder form */}
                {showNewFolderForm&&(
                    <div className="overlay">
                    <div className="add-new-folder-form">
                        <h3>مجلد جديد</h3>
                        <label>اسم المجلد</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={newFolder.folderName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setNewFolder({...newFolder, folderName: e.target.value});setShowWarning(false);setWarning("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <button className="add-new-folder-button" onClick={addNewFolder}>إضافة</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowNewFolderForm(false);setNewFolder({...newFolder,folderName:""});}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showEditFolderForm&&(
                    <div className="overlay">
                    <div className="add-new-folder-form">
                        <h3>تعديل المجلد</h3>
                        <label>اسم المجلد</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={objectToEdit.folderName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setObjectToEdit({...objectToEdit, folderName: e.target.value});setShowWarning(false);setWarning("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <button className="add-new-folder-button" onClick={updateFolder}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditFolderForm(false);setObjectToEdit({});}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showNewUnitForm&&(
                    <div className="overlay">
                    <div className="add-new-unit-form">
                        <h3>وحدة جديدة</h3>
                        <label>اسم الوحدة</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={newUnit.unitName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setNewUnit({...newUnit, unitName: e.target.value});setShowWarning(false);setWarning("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <button className="add-new-folder-button" onClick={addNewUnit}>إضافة</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowNewUnitForm(false);setNewUnit({...newUnit,unitName:""});}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showEditUnitForm&&(
                    <div className="overlay">
                    <div className="add-new-unit-form">
                        <h3>تعديل الوحدة</h3>
                        <label>اسم الوحدة</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={objectToEdit.unitName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setObjectToEdit({...objectToEdit, unitName: e.target.value});setShowWarning(false);setWarning("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <button className="add-new-folder-button" onClick={updateUnit}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditUnitForm(false);setObjectToEdit({});}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showNewLessonForm&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>درس جديد</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={newLesson.lessonName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setNewLesson({...newLesson, lessonName: e.target.value});setShowWarning(false);setWarning("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        {capacityExceeded && (
                            <p className="capacity-exceeded">سعة التخزين لا تكفي برجاء الترقية لاضافة المزيد من الدروس</p>
                        )}
                        <label>رابط الدرس من اليوتيوب</label>
                        <input type="text"
                        onChange={e=>{changeUrl(e.target.value)}}
                        ></input>
                        <label>السعر</label>
                        <input type="number"
                        value={newLesson.price}
                        onChange={(e)=>{setNewLesson({...newLesson,price: e.target.value})}} />

                        <button className="add-new-folder-button"
                        disabled={disapleAddingButtons}
                        
                        onClick={()=>{addNewLesson();}}>{disapleAddingButtons?<CircularProgress size={20} color="white" />:"إضافة"}</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowNewLessonForm(false);setNewLesson({...newLesson,lessonName:"",url:"",imageUrl:""});setCapacityExceeded(false);}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showEditLessonFrom&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>تعديل الدرس</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={objectToEdit.lessonName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setObjectToEdit({...objectToEdit, lessonName: e.target.value});setShowWarning(false);setWarning("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <label>السعر</label>
                        <input type="number"
                        value={objectToEdit.price}
                        onChange={(e)=>{setObjectToEdit({...objectToEdit,price: e.target.value})}} />

                        <button className="add-new-folder-button" onClick={updateLesson}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditLessonFrom(false);setObjectToEdit({});}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showDeleteLessonForm &&(
                    <div className="overlay">
                    <div className="delete-lesson-folder-unit-form">
                        {typeToDelete==="lesson"&& 
                        (
                        <div>
                            <h3>حذف الدرس</h3>
                            <p>هل انت متأكد أنك تريد حذف هذا الدرس؟</p>
                            <p>{objectToDelete.name}</p>
                            </div>)}

                        {typeToDelete==="unit"&& 
                        (
                        <div>
                            <h3>حذف وحدة</h3>
                            <p>هل انت متأكد أنك تريد حذف هذه الوحدة؟</p>
                            <p>سيؤدي هذا الي حذف الدروس والاختبارات في هذه الوحدة</p>
                            <p>{objectToDelete.name}</p>
                            </div>)}

                        {typeToDelete==="folder"&& 
                        (
                        <div>
                            <h3>حذف المجلد</h3>
                            <p>هل انت متأكد أنك تريد حذف هذا المجلد؟</p>
                            <p>سيؤدي هذا الي حذف كل الوحدات والدروس والاختبارات في هذا المجلد</p>
                            <p>{objectToDelete.name}</p>
                        </div>)}
                        {typeToDelete==="exam"&& 
                        (
                        <div>
                            <h3>حذف الإختبار</h3>
                            <p>هل انت متأكد أنك تريد حذف هذا الإختبار</p>
                            <p>{objectToDelete.name}</p>
                            </div>)}
                        <div className="lesson-delete-buttons">
                        <button className="lesson-delete-button" onClick={deleteObject}>نعم</button>
                        <button onClick={()=>setShowDeleteLessonForm(false)}>لا</button>
                    </div>
                    </div>
                    </div>

                )}

            </div>)}

            {ShowMessageToStartPlan&&(
                <div className="overlay">
                    <div className="subscribe-form">
                        <h3>يرجى الاشتراك في خطة اسعار لبدء نشر الدروس والاختبارات</h3>
                        <div style={{display:"flex",justifyContent:"space-between",width:"100%",padding:"10px"}}>
                        <button onClick={()=>{setShowMessageToStartPlan(false)}}>إلغاء</button>
                        <button onClick={()=>navigate("/admin-home/plans")}>خطط الاسعار</button>
                        </div>
                    </div>
                </div>
            )}

            {capacityExceeded&&(
                <div className="overlay">
                
                  <div className="subscribe-form">
                    <h3>برجاء التجديد / الترقية لمتابعة نشر الاختبارات والدروس</h3>
                    <div style={{display:"flex",justifyContent:"space-between",width:"100%",padding:"10px"}}>
                    <button onClick={()=>{setCapacityExceeded(false);}}>إلغاء</button>
                    <button onClick={()=>navigate("/admin-home/plans")}>خطط الاسعار</button>
                    </div>
                  </div>
                   </div>
                  )}

       </div>

    )

}